// extracted by mini-css-extract-plugin
module.exports = {"secondaryMenuHeader":"_1Kpb8 _1R_Wx","menuItemBigChevron":"_231oY"};